import { environment } from './enviroments';

const statusMap = {
    'init': {
        bgColor: '#ACC8E5',
        textColor: '#112A46',
    },
    'fail': {
        bgColor: '#F9CCC8',
        textColor: '#2C2826',
    },
    'ga': {
        bgColor: '#ECCDFE',
        textColor: '#112A46',
    },
    'ad': {
        bgColor: '#28a74580',
        textColor: '#000000',
    },
    'ad-light': {
        bgColor: '#28a74540',
        textColor: '#000000',
    },
    'game': {
        bgColor: '#FBD19D',
        textColor: '#112A46',
    },
    'push': {
        bgColor: '#fbc640',
        textColor: '#112A46',
    },
};

/**
 * console info log message with the status message colors
 *
 * @param message - string (required)
 * @param status - string (required)

 */
const consoleInfoLog = (message, status) => {
    environment() !== 'production' &&
        console.info(
            `%c${message}`,
            `background: ${statusMap[status].bgColor || '#C8DFFD'};
                           color: ${statusMap[status].textColor || '#3C0661'};
                           font-weight: 900; padding: 4px 5px;
                           border-radius: 3px`
        );
};

export default consoleInfoLog;
